// Separate entry point for arena page
// highlight.js is lazy-loaded only when JSON prompts are detected
// Include this script only on arena pages

function hasJsonPrompts(): boolean {
  const elements = document.querySelectorAll("[data-prompt-truncate-target='text']")
  for (const el of elements) {
    const text = el.textContent?.trim() || ""
    if (/^[\{\[]/.test(text)) {
      try {
        JSON.parse(text)
        return true
      } catch {
        // Not valid JSON
      }
    }
  }
  return false
}

async function highlightJsonPrompts() {
  if (!hasJsonPrompts()) return

  const [{ default: hljs }, { default: json }] = await Promise.all([
    import("highlight.js/lib/core"),
    import("highlight.js/lib/languages/json")
  ])

  hljs.registerLanguage("json", json)

  document.querySelectorAll("[data-prompt-truncate-target='text']").forEach((el) => {
    if (el.classList.contains("hljs")) return

    const text = el.textContent?.trim() || ""
    if (/^[\{\[]/.test(text)) {
      try {
        JSON.parse(text)
        el.classList.add("language-json")
        el.classList.remove("whitespace-pre-line")
        el.classList.add("whitespace-pre-wrap")
        hljs.highlightElement(el as HTMLElement)
      } catch {
        // Not valid JSON, skip highlighting
      }
    }
  })
}

// Run on initial load
highlightJsonPrompts()

// Run after Turbo navigations (full page)
document.addEventListener("turbo:load", highlightJsonPrompts)

// Run after Turbo Stream updates dispatched by the arena controller
document.addEventListener("arena:content-updated", highlightJsonPrompts)
